import { render } from "./BotonDirectorioStreamlined.vue?vue&type=template&id=64708016&scoped=true"
import script from "./BotonDirectorioStreamlined.vue?vue&type=script&lang=ts"
export * from "./BotonDirectorioStreamlined.vue?vue&type=script&lang=ts"

import "./BotonDirectorioStreamlined.vue?vue&type=style&index=0&id=64708016&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-64708016"

export default script